import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CottageIcon from '@mui/icons-material/Cottage';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import ListIcon from '@mui/icons-material/List';
import MoreIcon from '@mui/icons-material/MoreVert';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YoutubeIcon from '@mui/icons-material/YouTube';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { API } from "../../Services/api";
import MessageIcon from '@mui/icons-material/Message';
import Tooltip from '@mui/material/Tooltip';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Logo from '../../images/f&S_Informática_Logo.png'; // Ajuste o caminho para o local do seu logo

const theme = createTheme({
  palette: {
    primary: {
      main: '#f44336',
    },
    secondary: {
      main: '#ffffff',
    },
  },
});

export default function PrimarySearchAppBar() {
  const [user, setUser] = useState(null);
  const [turmas, setTurmas] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [usertype, setUsertype] = useState('');

  const navigate = useNavigate();

  const handleLoggout = () => {
    console.log('logout');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    API.defaults.headers.Authorization = null;
    setUser(null);
    navigate('/login');
    setAnchorEl(null);
    handleMenuClose();
  };

  const handleMainMenuClose = () => setMenuAnchorEl(null); // Fecha o menu principal
  const handleMainMenuOpen = (event) => setMenuAnchorEl(event.currentTarget); // Abre o menu principal

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setUsertype(storedUser.usertype);
      console.log('Usertype:', storedUser.usertype);
      console.log('User:', storedUser);
    }
  }, []);

  useEffect(() => {
    const storedTurmas = JSON.parse(localStorage.getItem('turmas'));
    if (storedTurmas) {
      setTurmas(storedTurmas);
    }
  }, []);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isMainMenuOpen = Boolean(menuAnchorEl); // Verifica se o menu está aberto

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileSandwichMenuOpen = (event) => {
    console.log('handleMobileSandwichMenuOpen');
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMobileMenuOpen = (event) => {
    console.log('handleMobileMenuOpen');
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const naviggateToProfile = () => {
    console.log('naviggateToProfile');
    navigate('/profile');
    handleMenuClose();
  };

  const naviggateToHome = () => {
    console.log('naviggateToHome');
    navigate('/');
    setAnchorEl(null);
    handleMenuClose();
  };

  const handleDashboard = () => {
    navigate('/admin');
    setAnchorEl(null);
    handleMenuClose();
  };

  const handleInstagram = () => {
    // window.open('');
  };

  const handleFacebook = () => {
    // window.open('');
  };

  const handleYoutube = () => {
    // window.open('');
  };

  const handleTimelineMessages = () => {
    navigate('/timeline');
    setAnchorEl(null);
    handleMenuClose();
  };

  const handlePayments = () => {
    navigate('/payments');
    setAnchorEl(null);
    handleMenuClose();
  };

  const renderMainMenu = (
    <Menu
      anchorEl={menuAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id="primary-main-menu"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMainMenuOpen}
      onClose={handleMainMenuClose}
    >
      <MenuItem onClick={() => { navigate('/admissao'); handleMainMenuClose(); }}>Admissão</MenuItem>
      <MenuItem onClick={() => { navigate('/nossa-escola'); handleMainMenuClose(); }}>Nossa Escola</MenuItem>
      <MenuItem onClick={() => { navigate('/niveis-de-ensino'); handleMainMenuClose(); }}>Níveis de Ensino</MenuItem>
      <MenuItem onClick={() => { navigate('/programas'); handleMainMenuClose(); }}>Programas</MenuItem>
      <MenuItem onClick={() => { navigate('/conteudos'); handleMainMenuClose(); }}>Conteúdos</MenuItem>
      <MenuItem onClick={() => { navigate('/agenda'); handleMainMenuClose(); }}>Agenda</MenuItem>
      <MenuItem onClick={() => { navigate('/area-do-responsavel'); handleMainMenuClose(); }}>Área do responsável</MenuItem>
      <MenuItem onClick={() => { navigate('/contato'); handleMainMenuClose(); }}>Contato</MenuItem>
    </Menu>
  );

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id="primary-search-account-menu"
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={naviggateToProfile}>Perfil</MenuItem>
      <MenuItem onClick={naviggateToHome}>Home</MenuItem>
      <MenuItem onClick={handleMenuClose}>Informes</MenuItem>
      <MenuItem onClick={handlePayments}>Pagamentos</MenuItem>
      {localStorage.getItem('user') && usertype === 'administrator' && (
        <MenuItem onClick={handleDashboard}>Dashboard</MenuItem>
      )}
      <MenuItem onClick={handleLoggout}>
        {localStorage.getItem('user') ? 'Sair' : 'Entrar'}
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id="primary-search-account-menu-mobile"
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={naviggateToHome}>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge color="error">
            <CottageIcon />
          </Badge>
        </IconButton>
        <p>Home</p>
      </MenuItem>
      {localStorage.getItem('user') && usertype === 'administrator' && (
        <MenuItem onClick={handleDashboard}>
          <IconButton size="large" aria-label="show 17 new notifications" color="inherit">
            <Badge color="error">
              <DashboardIcon />
            </Badge>
          </IconButton>
          <p>Dashboard</p>
        </MenuItem>
      )}
      <MenuItem onClick={naviggateToProfile}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
      <MenuItem onClick={handleTimelineMessages}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <MessageIcon />
        </IconButton>
        <p>Informes</p>
      </MenuItem>
      <MenuItem onClick={handlePayments}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <CreditCardIcon />
        </IconButton>
        <p>Pagamentos</p>
      </MenuItem>
      {localStorage.getItem('user') && (
        <MenuItem onClick={handleLoggout}>
          <IconButton
            size="large"
            aria-label="logout of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <LogoutIcon />
          </IconButton>
          <p>Logout</p>
        </MenuItem>
      )}
      {!localStorage.getItem('user') && (
        <MenuItem onClick={() => navigate('/login')}>
          <IconButton
            size="large"
            aria-label="login of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <LoginIcon />
          </IconButton>
          <p>Login</p>
        </MenuItem>
      )}
    </Menu>
  );

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 2 }}
              onClick={handleMainMenuOpen} // Abre o menu principal
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ display: { xs: 'none', sm: 'block' }, flexGrow: 1 }}
            >
              <img src={Logo} alt="Logo" height={40} />
            </Typography>
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
              <Tooltip title="Instagram">
                <IconButton size="large" color="inherit" onClick={handleInstagram}>
                  <InstagramIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Facebook">
                <IconButton size="large" color="inherit" onClick={handleFacebook}>
                  <FacebookIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="YouTube">
                <IconButton size="large" color="inherit" onClick={handleYoutube}>
                  <YoutubeIcon />
                </IconButton>
              </Tooltip>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Tooltip title="Home">
                <IconButton size="large" color="inherit" onClick={naviggateToHome}>
                  <CottageIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Timeline">
                <IconButton size="large" color="inherit" onClick={handleTimelineMessages}>
                  <MessageIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Payments">
                <IconButton size="large" color="inherit" onClick={handlePayments}>
                  <CreditCardIcon />
                </IconButton>
              </Tooltip>
              {localStorage.getItem('user') && usertype === 'administrator' && (
                <Tooltip title="Dashboard">
                  <IconButton size="large" color="inherit" onClick={handleDashboard}>
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              )}
              {localStorage.getItem('user') ? (
                <Tooltip title="Logout">
                  <IconButton size="large" color="inherit" onClick={handleLoggout}>
                    <LogoutIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Login">
                  <IconButton size="large" color="inherit" onClick={() => navigate('/login')}>
                    <LoginIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Toolbar>
        </AppBar>
        {renderMenu}
        {renderMobileMenu}
        {renderMainMenu}
      </Box>
    </ThemeProvider>
  );
}
